import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

// Shared AI-limit handling: plain message, plus an upgrade path for Free-plan users.
export const UPGRADE_COPY = "Pro includes 60 AI analyses a month and Family includes 120. Your allowance resets at the start of each month.";

export function aiLimitDetail(e) {
  const d = e?.response?.status === 429 ? e?.response?.data?.detail : null;
  return d && typeof d === "object" && d.code === "AI_LIMIT_REACHED" ? d : null;
}

export function notifyAiLimit(d, navigate = (to) => window.location.assign(to)) {
  const opts = d.tier === "FREE" ? { description: UPGRADE_COPY, action: { label: "See plans", onClick: () => navigate("/pricing") } } : {};
  toast.error(d.message, opts);
}

export const UpgradePrompt = ({ message, tier }) => (
  <div data-testid="ai-limit-prompt" className="rounded-lg bg-white/5 border border-white/10 px-4 py-3 text-[13px] text-tc-sub">
    <p data-testid="ai-limit-message">{message}</p>
    {tier === "FREE" && (
      <>
        <p className="mt-1.5 text-tc-muted">{UPGRADE_COPY}</p>
        <Link to="/pricing" data-testid="ai-limit-upgrade-link" className="inline-block mt-2.5 rounded-lg bg-tc-coach text-tc-bg font-semibold px-4 py-2 text-[12px]">See Pro and Family plans</Link>
      </>
    )}
  </div>
);
